var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"lime"},[_vm._v("404")]),_c('h1',[_vm._v("Woops. You've hit a dead end. Let's try that again.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }